var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgResultNotFound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 121,
    height: 117,
    viewBox: "0 0 121 117",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M62.0135 111.686C75.1162 111.686 87.6822 106.481 96.9472 97.2163C106.212 87.9513 111.417 75.3853 111.417 62.2826C111.417 49.1799 106.212 36.6139 96.9472 27.3489C87.6822 18.0839 75.1162 12.8789 62.0135 12.8789C34.7383 12.8789 12.6099 34.9798 12.6099 62.2551C12.6099 89.5303 34.7383 111.686 62.0135 111.686Z",
    fill: "url(#paint0_linear_2781_29130)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M88.6832 24.3555H33.94C32.3056 24.3577 30.7388 25.0079 29.583 26.1636C28.4273 27.3193 27.7771 28.8862 27.7749 30.5206H94.8758C94.8678 28.8832 94.2119 27.3156 93.0515 26.1603C91.8911 25.0051 90.3206 24.3562 88.6832 24.3555Z",
    fill: "url(#paint1_linear_2781_29130)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7749 30.3555H94.8758V81.4656C94.8769 82.5899 94.6563 83.7035 94.2265 84.7425C93.7967 85.7815 93.1662 86.7255 92.3712 87.5206C91.5761 88.3156 90.6321 88.9461 89.5931 89.3758C88.5541 89.8056 87.4406 90.0263 86.3162 90.0252H36.3345C35.2102 90.0263 34.0966 89.8056 33.0576 89.3758C32.0186 88.9461 31.0746 88.3156 30.2795 87.5206C29.4845 86.7255 28.854 85.7815 28.4243 84.7425C27.9945 83.7035 27.7738 82.5899 27.7749 81.4656V30.3555Z",
    fill: "url(#paint2_linear_2781_29130)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M83.3163 36.8245H39.3071C38.8692 36.8245 38.4491 36.9985 38.1394 37.3082C37.8297 37.6179 37.6558 38.0379 37.6558 38.4759C37.6558 38.9139 37.8297 39.3339 38.1394 39.6436C38.4491 39.9533 38.8692 40.1273 39.3071 40.1273H83.3163C83.7543 40.1273 84.1743 39.9533 84.484 39.6436C84.7937 39.3339 84.9677 38.9139 84.9677 38.4759C84.9718 38.2579 84.9319 38.0413 84.8504 37.8391C84.7688 37.6369 84.6473 37.4532 84.4932 37.299C84.339 37.1449 84.1553 37.0234 83.9531 36.9418C83.7509 36.8603 83.5343 36.8204 83.3163 36.8245Z",
    fill: "url(#paint3_linear_2781_29130)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M83.3163 50.889H39.3071C38.8692 50.889 38.4491 51.0629 38.1394 51.3726C37.8297 51.6823 37.6558 52.1024 37.6558 52.5403C37.6558 52.9783 37.8297 53.3983 38.1394 53.708C38.4491 54.0177 38.8692 54.1917 39.3071 54.1917H83.3163C83.7543 54.1917 84.1743 54.0177 84.484 53.708C84.7937 53.3983 84.9677 52.9783 84.9677 52.5403C84.9718 52.3223 84.9319 52.1058 84.8504 51.9035C84.7688 51.7013 84.6473 51.5177 84.4932 51.3635C84.339 51.2093 84.1553 51.0878 83.9531 51.0063C83.7509 50.9248 83.5343 50.8848 83.3163 50.889Z",
    fill: "url(#paint4_linear_2781_29130)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M83.3163 64.9808H39.3071C38.8692 64.9808 38.4491 65.1547 38.1394 65.4644C37.8297 65.7741 37.6558 66.1942 37.6558 66.6321C37.6558 67.0701 37.8297 67.4901 38.1394 67.7998C38.4491 68.1095 38.8692 68.2835 39.3071 68.2835H83.3163C83.7543 68.2835 84.1743 68.1095 84.484 67.7998C84.7937 67.4901 84.9677 67.0701 84.9677 66.6321C84.9718 66.4141 84.9319 66.1976 84.8504 65.9953C84.7688 65.7931 84.6473 65.6094 84.4932 65.4553C84.339 65.3011 84.1553 65.1796 83.9531 65.0981C83.7509 65.0166 83.5343 64.9766 83.3163 64.9808Z",
    fill: "url(#paint5_linear_2781_29130)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M83.3163 79.0723H39.3071C38.8692 79.0723 38.4491 79.2463 38.1394 79.5559C37.8297 79.8656 37.6558 80.2857 37.6558 80.7236C37.6558 81.1616 37.8297 81.5816 38.1394 81.8913C38.4491 82.201 38.8692 82.375 39.3071 82.375H83.3163C83.7543 82.375 84.1743 82.201 84.484 81.8913C84.7937 81.5816 84.9677 81.1616 84.9677 80.7236C84.9677 80.2857 84.7937 79.8656 84.484 79.5559C84.1743 79.2463 83.7543 79.0723 83.3163 79.0723Z",
    fill: "url(#paint6_linear_2781_29130)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M95.1786 80.3105L88.8208 87.3289L106.738 103.595L113.096 96.5766L95.1786 80.3105Z",
    fill: "url(#paint7_linear_2781_29130)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M101.894 68.6964C101.894 73.9493 100.336 79.0844 97.4181 83.4521C94.4997 87.8198 90.3516 91.224 85.4985 93.2342C80.6454 95.2445 75.3051 95.7705 70.153 94.7456C65.001 93.7208 60.2685 91.1913 56.554 87.4768C52.8396 83.7624 50.3101 79.0299 49.2852 73.8779C48.2604 68.7258 48.7864 63.3856 50.7966 58.5324C52.8069 53.6793 56.2111 49.5312 60.5788 46.6128C64.9465 43.6944 70.0816 42.1367 75.3346 42.1367C78.8225 42.1364 82.2764 42.8231 85.4989 44.1577C88.7214 45.4923 91.6495 47.4487 94.1159 49.915C96.5822 52.3814 98.5386 55.3095 99.8732 58.532C101.208 61.7545 101.895 65.2084 101.894 68.6964ZM97.8208 68.6964C97.8208 73.1437 96.502 77.4912 94.0312 81.189C91.5604 84.8869 88.0485 87.769 83.9397 89.4709C79.8308 91.1729 75.3096 91.6182 70.9477 90.7505C66.5858 89.8829 62.5791 87.7413 59.4344 84.5965C56.2896 81.4518 54.148 77.4451 53.2804 73.0832C52.4127 68.7213 52.858 64.2001 54.56 60.0912C56.2619 55.9824 59.144 52.4705 62.8419 49.9997C66.5397 47.5289 70.8872 46.2101 75.3346 46.2101C81.2976 46.2123 87.0158 48.5821 91.2323 52.7986C95.4488 57.0151 97.8186 62.7333 97.8208 68.6964Z",
    fill: "url(#paint8_linear_2781_29130)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M75.3617 91.1815C79.8091 91.1815 84.1566 89.8627 87.8544 87.3919C91.5523 84.921 94.4344 81.4092 96.1363 77.3003C97.8382 73.1915 98.2835 68.6703 97.4159 64.3084C96.5483 59.9465 94.4067 55.9398 91.2619 52.7951C88.1171 49.6503 84.1105 47.5087 79.7486 46.6411C75.3867 45.7734 70.8654 46.2187 66.7566 47.9207C62.6478 49.6226 59.1359 52.5047 56.6651 56.2025C54.1943 59.9004 52.8755 64.2479 52.8755 68.6952C52.8777 74.6583 55.2475 80.3765 59.464 84.593C63.6805 88.8095 69.3987 91.1793 75.3617 91.1815Z",
    fill: "url(#paint9_linear_2781_29130)",
    fillOpacity: 0.2
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M80.7564 68.6955L87.1967 62.2552C87.7949 61.6126 88.1206 60.7631 88.1052 59.8853C88.0898 59.0075 87.7345 58.1699 87.1142 57.5488C86.4909 56.9297 85.653 56.5748 84.7747 56.5579C83.9005 56.557 83.057 56.8806 82.4077 57.4662L75.9674 63.9066L69.527 57.4662C69.214 57.1398 68.8399 56.8779 68.4261 56.6955C68.0115 56.5071 67.5603 56.4131 67.105 56.4203C66.653 56.4199 66.205 56.5039 65.7839 56.668C65.3612 56.8366 64.9773 57.0894 64.6555 57.4111C64.3279 57.7282 64.0742 58.1134 63.9123 58.5396C63.7457 58.96 63.6616 59.4085 63.6646 59.8607C63.6737 60.3143 63.767 60.7623 63.9399 61.1818C64.1291 61.5917 64.3901 61.9646 64.7105 62.2827L71.1509 68.7231L64.7931 75.1359C64.4666 75.4489 64.2048 75.823 64.0224 76.2368C63.834 76.6514 63.74 77.1026 63.7472 77.5579C63.7468 78.0099 63.8308 78.4579 63.9949 78.879C64.1635 79.3017 64.4163 79.6857 64.738 80.0075C65.055 80.335 65.4403 80.5887 65.8665 80.7506C66.2869 80.9172 66.7354 81.0013 67.1876 80.9983C67.6412 80.9892 68.0892 80.8959 68.5087 80.7231C68.9225 80.5407 69.2965 80.2788 69.6096 79.9524L76.0499 73.5121L82.4903 79.9524C82.8053 80.2395 83.1746 80.4604 83.5764 80.6022C83.9782 80.7441 84.4044 80.8039 84.8298 80.7781C85.472 80.7602 86.0958 80.5592 86.6276 80.1987C87.1594 79.8382 87.5772 79.3332 87.8316 78.7433C88.0861 78.1534 88.1667 77.503 88.064 76.8688C87.9613 76.2345 87.6795 75.6429 87.2518 75.1634L80.7564 68.6955Z",
    fill: "url(#paint10_linear_2781_29130)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M106.739 103.567L113.097 96.5488L114.06 97.4296C114.521 97.8458 114.895 98.3498 115.16 98.9121C115.425 99.4744 115.575 100.084 115.601 100.705C115.656 101.956 115.222 103.18 114.39 104.118C113.974 104.579 113.47 104.953 112.908 105.218C112.345 105.482 111.736 105.632 111.115 105.659C109.863 105.714 108.639 105.279 107.702 104.448L106.739 103.567Z",
    fill: "#D1D1D1"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2781_29130",
    x1: 62.6438,
    y1: -26.5018,
    x2: 62.6438,
    y2: 170.288,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#969A9C",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.841934,
    stopColor: "#E3E4E4",
    stopOpacity: 0.923958
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8E8E8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2781_29130",
    x1: 27.7226,
    y1: 25.2802,
    x2: 94.9254,
    y2: 30.0169,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B5B8B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8E8E8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2781_29130",
    x1: 26.0272,
    y1: 59.4885,
    x2: 122.955,
    y2: 61.2114,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B5B8B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4F4F4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2781_29130",
    x1: 35.6576,
    y1: 38.4759,
    x2: 87.7833,
    y2: 38.4759,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.913542,
    stopColor: "#E8E8E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2781_29130",
    x1: 35.6576,
    y1: 52.5403,
    x2: 87.7833,
    y2: 52.5403,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.913542,
    stopColor: "#E8E8E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2781_29130",
    x1: 35.6576,
    y1: 66.6321,
    x2: 87.7833,
    y2: 66.6321,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.913542,
    stopColor: "#E8E8E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2781_29130",
    x1: 35.6576,
    y1: 80.7236,
    x2: 87.7833,
    y2: 80.7236,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B5B8B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.908333,
    stopColor: "#E8E8E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D2F7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2781_29130",
    x1: 97.763,
    y1: 95.4592,
    x2: 104.179,
    y2: 88.4216,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B5B8B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8E8E8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2781_29130",
    x1: 48.6456,
    y1: 68.523,
    x2: 102.101,
    y2: 68.8697,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B5B8B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8E8E8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_2781_29130",
    x1: 67.8149,
    y1: 49.1209,
    x2: 90.4691,
    y2: 107.902,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1F1F1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_2781_29130",
    x1: 64.1408,
    y1: 57.7689,
    x2: 88.5536,
    y2: 80.5744,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D6D6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D2D2D2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResultNotFound);
export default __webpack_public_path__ + "static/media/result-not-found.1f5b877a1a8b496a948cdfe3ede41d75.svg";
export { ForwardRef as ReactComponent };